async function sendAttachments(commit, files, message_id)
{
     const formData = new FormData();
     formData.append('message_id', message_id);
    for (const file of files) {
        formData.append('files[]', file);
    }

    const response = await axios.post('attachments', formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })

    let data = response.data;
    console.log(data)
}

const state = {
    messagesAdmin: [],
    messages: [],
    nbMessages: 0,
    rooms: [],
}

const getters = {
    allMessagesAdmin: state => state.messagesAdmin,
    allMessages: state => state.messages,
    allRooms: state => state.rooms,
    nbMessages: state => state.nbMessages,
    getMessage: (state) => (id) => {
        return state.message.find((el) => el.id === id);
    }
}

const actions = {
    fetchAllMessagesAdmin({commit}) {
        return axios.get('/admin/' + Vue.auth.user().id + '/message').then((res) => commit('SET_MESSAGES_ADMIN', res.data))
    },
    fetchAllMessagesCount({commit}) {
        return axios.get('/user/' + Vue.auth.user().id + '/messages/nbUnreadMessages').then((res) => commit('SET_MESSAGES_COUNT', res.data))
    },
    fetchAllMessages({commit}) {
        return axios.get('/user/' + Vue.auth.user().id + '/message').then((res) => commit('SET_MESSAGES', res.data))
    },
    fetchAllRooms({commit, state}, chunk) {
        return axios.get('/user/' + Vue.auth.user().id + '/rooms-' + chunk).then((res) => {
            commit('ADD_ROOMS', res.data);
            return res.data
        })
    },
    fetchAllRoomsWithReset({commit}, chunk) {
        return axios.get('/user/' + Vue.auth.user().id + '/rooms-' + chunk).then(res => {
            commit('ADD_ROOMS_WITH_RESET', res.data);
        })
    },

    fetchRoom({commit}, id) {
        return axios.get('/user/' + Vue.auth.user().id + '/rooms/' + id).then(res => {
            commit('UPDATE_ROOM', res.data);
        })
    },

    updateRoomName({commit}, data) {
        let payload = {custom_name : data.custom_name }
        return axios.put('/user/' + Vue.auth.user().id + '/rooms/' + data.room_id, payload).then(res => {
            return res.data;
        })
    },

    deleteRoom({commit}, roomId) {
        return axios.delete('/user/' + Vue.auth.user().id + '/rooms/' + roomId).then(res => {
            commit('REMOVE_ROOM', roomId)
        })
    },

    async newMessage({commit}, message) {
        let index = message.index;
        delete message.index;
        const res = await axios.post('/user/' + Vue.auth.user().id + '/conversations', message);
        if (res){
            res.index = index;
            if (message.filesSend)
                await sendAttachments(commit, message.filesSend, res.data.id);
            commit('NEW_MESSAGE', res);
        }
        return res
    },
    newMessageNotAuth({commit}, message) {
        return axios.post('/message', message).then(res => {
            // if(res)commit('NEW_MESSAGE', res)
        })
    },
    markAsRead({commit}, messages) {
        messages.forEach(message => {
            return axios.put('/user/' + Vue.auth.user().id + '/message/' + message.id, {
                read: 1
            }).then(res => {
                commit('MARK_AS_READ', res.data)
            })
        });
    },


    removeAdminMessage({commit}, message) {
        return axios.delete('/admin/' + Vue.auth.user().id + '/message/' + message.id).then(res => commit('REMOVE_MESSAGE_ADMIN', message.id))
    },
    markAsReadAdmin({commit}, message) {
        return axios.put('/admin/' + Vue.auth.user().id + '/message/' + message.id, {
            read: 1
        }).then(res => {
            commit('MARK_AS_READ_ADMIN', res.data)
        })
    },
    // addCar({ commit }, id, name = null) {
    //
    // },
}

const mutations = {
    SET_MESSAGES_ADMIN: (state, messages) => state.messagesAdmin = messages,
    ADD_ROOMS: (state, rooms) => {
        state.rooms = [...state.rooms, ...rooms];
    },
    ADD_ROOMS_WITH_RESET: (state, rooms) => {
        state.rooms = [...rooms];
    },
    UPDATE_ROOM: (state, room) => {
        let i = state.rooms.findIndex(r => r.id === room[0].id);
        if(i !== -1) {
            Vue.set(state.rooms, i, room[0]);
        }
    },
    SET_MESSAGES: (state, messages) => state.messages = messages,
    NEW_MESSAGE: (state, message) => {
        if (state.messagesAdmin && state.messages.products && state.messages.researches) {
            state.messagesAdmin.unshift(message.data)
            if (message.data.type == 'direct') {
                let i = message.index;
                state.messages.direct[i].messages.push(message.data);
                let product = state.messages.direct[i];
                state.messages.direct.splice(i, 1);
                state.messages.direct.unshift(product);
            } else {
                let i = message.index
                if (i !== -1) {
                    state.messages.products[i].messages.push(message.data);
                    let product = state.messages.products[i];
                    state.messages.products.splice(i, 1);
                    state.messages.products.unshift(product);
                } else {
                    i = message.index
                    if (i !== -1) {
                        state.messages.researches[i].messages.push(message.data);
                        let research = state.messages.researches[i];
                        state.messages.researches.splice(i, 1);
                        state.messages.researches.unshift(research);
                    }
                }
            }
        }
    },

    EDIT_MESSAGE_ADMIN: (state, message) => {
        let i = state.messagesAdmin.findIndex(m => m.id === message.id)
        Vue.set(state.messagesAdmin, i, message);
    },
    SET_MESSAGES_COUNT: (state, count) => {
        state.nbMessages = count
    },
    REMOVE_MESSAGE_ADMIN: (state, id) => {
        let index = state.messagesAdmin.findIndex(c => c.id === id);
        state.messagesAdmin.splice(index, 1);
    },
    MARK_AS_READ: (state, message) => {
        if(!state.messages || state.messages.length === 0) {
            return;
        }
        let index = state.messages.findIndex(m => m.id === message.id);
        if(index !== -1){
            // Set read to that specific message and not replace the entire message :
            let readMessage = state.messages[index];
            readMessage.read = 1;
            Vue.set(state.messages, index, readMessage);
            state.nbMessages -= 1;
        }
    },
    MARK_AS_READ_ADMIN: (state, message) => {
        let item = state.messagesAdmin.find(el => el.id === message.id)
        item.read = 1
    },

    REMOVE_MESSAGE_ATTACHMENT: (state, { messageId, attachmentId }) => {
        const message = state.messagesAdmin.find(m => m.id === messageId);
        if (!message || !message.attachments) return;
        const index = message.attachments.findIndex(a => a.id === attachmentId);
        if (index !== -1) message.attachments.splice(index, 1);
    },
    UPDATE_MESSAGE_ATTACHMENT: (state, { messageId, attachment }) => {
        const message = state.messagesAdmin.find(m => m.id === messageId);
        if (!message || !message.attachments) return;
        const index = message.attachments.findIndex(a => a.id === attachment.id);
        if (index !== -1) {
            Vue.set(message.attachments, index, { ...message.attachments[index], ...attachment });
        }
    },
    REMOVE_ROOM: (state, id) => {
        let index = state.rooms.findIndex(c => c.id === id);
        state.rooms.splice(index, 1);
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
